import { Routes } from "@angular/router";
import { InventoryPurchaseComponent } from "./inventory-purchase.component";
import { InventoryPurchaseListingComponent } from "./inventory-purchase-listing/inventory-purchase-listing.component";
import { InventoryPurchaseLinesComponent } from "./inventory-purchase-lines/inventory-purchase-lines.component";
import { InventoryPurchaseHeaderComponent } from "./inventory-purchase-header/inventory-purchase-header.component";
import { InventoryPurchaseSummaryComponent } from "./inventory-purchase-summary/inventory-purchase-summary.component";
import { InventoryPurchaseLineServicesFormComponent } from "./inventory-purchase-line-services-form/inventory-purchase-line-services-form.component";
import { FinishedGoodsTemplateComponent } from "./finished-goods-template/finished-goods-template.component";

export const inventoryPurchaseRoutes: Routes = [
  { path: "", component: InventoryPurchaseComponent },
  {
    path: "inventory-purchase-listing",
    component: InventoryPurchaseListingComponent,
  },
  {
    path: "inventory-purchase-lines/:purchaseOrderNumber",
    component: InventoryPurchaseLinesComponent,
  },
  {
    path: "inventory-purchase-header",
    component: InventoryPurchaseHeaderComponent,
  },
  {
    path: "inventory-purchase-summary/:samplePONumber",
    component: InventoryPurchaseSummaryComponent,
  },
  {
    path: "inventory-purchase-service-lines/:id",
    component: InventoryPurchaseLineServicesFormComponent,
  },
  {
    path: "inventory-purchase-finished-goods-template",
    component: FinishedGoodsTemplateComponent,
  },
];
